import { CRAFTER_LOCALES } from '../../common/EsCrafter';
import { useEsTranslationsFlag } from '../../common/EsFlags';
import { EsLocaleName } from '../../common/EsLocaleFlag';
import { esMenuLocales } from '../../common/EsLocaleMenu';
import { useEsStrings } from '../../common/EsStrings';
import { esLanguageOf, useEsCurrentLocale, useEsLocale, useEsLocalePick, useEsLocales } from '../../common/EsLocale';

/* The account page's language choice, drawn while rolloutEsTranslations or switchEsCrafter is on:
   with both off every word on the page is esfront's English and a picker would choose nothing.
   It picks the way the nav's menu does (useEsLocalePick): a signed-in reader's pick is saved to
   the account, so esback mails them in it too; an anonymous one is this browser's (EsLocale).
   Copykeys on, it offers the menu's locales, each with its flag (EsLocaleFlag); off, Crafter's
   languages, as they were. */
export default function EsLocalePicker() {
    const t = useEsStrings();
    const aOn = useEsTranslationsFlag();
    const aLocale = useEsLocale();
    const aCurrent = useEsCurrentLocale();
    const aLocales = useEsLocales();
    const pick = useEsLocalePick();

    const aChoices = aOn
        ? esMenuLocales( aLocales, aCurrent ).map( ( pGroup ) => ( { key: pGroup.key, label: <EsLocaleName group={ pGroup } />, lang: pGroup.key } ) )
        : CRAFTER_LOCALES.map( ( pLocale ) => ( { key: pLocale, label: pLocale, lang: pLocale } ) );
    const pressed = ( pKey ) => ( aOn ? pKey === aCurrent : pKey === esLanguageOf( aLocale ) );

    return (
        <div data-testid="es-account-locale" className="flex flex-wrap items-center gap-2 text-sm" role="group" aria-label={ t( 'account-settings-language', 'Language' ) }>
            { aChoices.map( ( pChoice ) => (
                <button key={ pChoice.key } type="button" data-testid={ `es-account-locale-${ pChoice.key }` }
                        lang={ pChoice.lang }
                        aria-pressed={ pressed( pChoice.key ) }
                        onClick={ () => pick( pChoice.key ) }
                        className={ ( aOn ? 'rounded-sm px-1 text-body ring-focus focus:ring-2 ' : 'rounded-sm px-1 uppercase text-body ring-focus focus:ring-2 ' )
                            + ( pressed( pChoice.key ) ? 'font-bold underline' : 'opacity-70 hover:opacity-100' ) }>
                    { pChoice.label }
                </button>
            ) ) }
        </div>
    );
}
